import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { colors, fontWeights, breakpoints } from '@/styles'
import ENV_VARS from '@/config'
import { H5, Label } from '@/components/text'

const { WEB_URL } = ENV_VARS

const HeadingText = styled(H5)`
  font-size: 20px;
  line-height: 28px;
  color: ${colors.black};
  margin: 0 0 8px;
  text-align: left;

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    margin: 0 0 4px;
  }
`

const SubheadingText = styled(Label)`
  color: ${colors.grey24};
  font-weight: 400;
  text-align: left;

  > a {
    font-weight: ${fontWeights.medium};
    color: ${colors.link};
    cursor: pointer;
  }
`

const Container = styled.div`
  margin: 0 0 ${props => props.bottom}px;
`

const HeaderDiv = ({ headingText, subheadingText, hasSignUpHereLink, bottom = 32 }) => {
  const { t } = useTranslation()
  const location = useLocation()
  const redirectParam = new URLSearchParams(location.search).get('redirect')
  const redirectPath = redirectParam ? `&redirect=${encodeURIComponent(redirectParam)}` : ``

  return (
    <Container bottom={bottom}>
      <HeadingText>{headingText}</HeadingText>
      {hasSignUpHereLink ? (
        <SubheadingText fontSize="14px">
          {t('b.landing.view.dont_have_an_account.text', 'Don’t have an account?')}
          <a id="btn-dashboard-signuphere" href={`${WEB_URL}/?signup${redirectPath}`}>
            &nbsp;{t('b.landing.view.sign_up_here.text', 'Sign up here')}
          </a>
          .
        </SubheadingText>
      ) : (
        <SubheadingText fontSize="14px">{subheadingText}</SubheadingText>
      )}
    </Container>
  )
}

export default HeaderDiv
